import { PricelistStateType } from '@g2-shared/api-client/generated/pricing-app';

export const PriceListStateTypeOptions = {
  [PricelistStateType.CREATING]: 'CREATING',
  [PricelistStateType.SETTING_DEFINITION]: 'SETTING_DEFINITION',
  [PricelistStateType.FORMING]: 'FORMING',
  [PricelistStateType.PREPARED]: 'PREPARED',
  [PricelistStateType.VERIFIED]: 'VERIFIED',
  [PricelistStateType.REJECTED]: 'REJECTED',
  [PricelistStateType.ACTIVATED]: 'ACTIVATED',
  [PricelistStateType.DEACTIVATED]: 'DEACTIVATED',
  [PricelistStateType.CLOSED]: 'CLOSED',
  [PricelistStateType.DELETED]: 'DELETED',
};
